import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

// import { PageLoader } from '@repo/design-system/components/ui';
import Header from '../header/Header';
import Sidebar from '../sidebar/Sidebar';

import './MainLayout.scss';

// Design System breakpoint: the sidebar is visible (and can collapse) only from 992px
const DESKTOP_QUERY = '(min-width: 992px)';
const isDesktopWidth = () => typeof window !== 'undefined' && window.matchMedia(DESKTOP_QUERY).matches;

const MainLayout = ({ componentRoutes, sidebarMenuConfig,
  isVisibleHeaderLogo
}) => {

  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [flyout, setFlyout] = useState(null);
  const [isDesktop, setIsDesktop] = useState(isDesktopWidth);

  // Below 992px the sidebar is an overlay: it closes when the screen becomes 992px or wider
  useEffect(() => {
    const mql = window.matchMedia(DESKTOP_QUERY);
    const handleChange = (e) => {
      setIsDesktop(e.matches);
      if (e.matches) setIsMobileOpen(false);
    };
    // addListener: Safari < 14 has no addEventListener on MediaQueryList
    if (mql.addEventListener) mql.addEventListener('change', handleChange);
    else mql.addListener(handleChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', handleChange);
      else mql.removeListener(handleChange);
    };
  }, []);

  // The open overlay sidebar also closes on the Esc key
  useEffect(() => {
    if (!isMobileOpen) return undefined;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setIsMobileOpen(false);
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isMobileOpen]);

  const toggleMobileSidebar = () => {
    setIsMobileOpen(prev => !prev);
  };

  const toggleCollapse = () => {
    setIsCollapsed((prev) => {
      if (!prev) { setOpenMenu(null); setFlyout(null); }
      return !prev;
    });
  };


  return (
    <>
      <div className="admin-layout">
        {isVisibleHeaderLogo ? null : (
          <Sidebar componentRoutes={componentRoutes} isMobileOpen={isMobileOpen}
            setIsMobileOpen={setIsMobileOpen} menuConfig={sidebarMenuConfig}
            isCollapsed={isCollapsed && isDesktop} setIsCollapsed={setIsCollapsed}
            setOpenMenu={setOpenMenu} openMenu={openMenu}
            flyout={flyout} setFlyout={setFlyout} />
        )}
        <div className="main-content">
          <Header toggleMobileSidebar={toggleMobileSidebar} isVisibleHeaderLogo={isVisibleHeaderLogo}
            toggleCollapse={toggleCollapse} isCollapsed={isCollapsed} />
          <main className="content-area">
            {/* <Suspense fallback={<PageLoader />}> */}
            <Outlet />
            {/* </Suspense> */}
          </main>
        </div>
      </div>
    </>
  );
};

MainLayout.propTypes = {
  componentRoutes: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      securityKey: PropTypes.string,
      children: PropTypes.arrayOf(
        PropTypes.shape({
          path: PropTypes.string.isRequired,
          securityKey: PropTypes.string,
        })
      ),
    })
  ).isRequired,
};

export default MainLayout;
